import * as R from 'ramda';
import React, { useMemo } from 'react';
// components
import { Table } from '../../../components/table';
// helpers/constants
import * as G from '../../../helpers';
// hooks
import useEditViewHook from '../../../hooks/use-edit-view';
// icons
import * as I from '../../../svgs';
// ui
import { IconWrapper } from '../../../ui';
// feature payroll
import {
  dailyHoursReport,
  getDefaultReportFields,
  dailyHoursTableSettings,
  dailyHoursColumnSettings,
} from '../settings/charges-table-settings';
//////////////////////////////////////////////////

const DailyHoursTab = (props: Object) => {
  const { maxHeight, dailyHours, handleClickDriverDailyHoursActions } = props;

  const tableSettings = R.assoc('maxHeight', maxHeight, dailyHoursTableSettings);

  const { uiReportFields, handleOpenEditView } = useEditViewHook({
    ...props,
    report: dailyHoursReport,
    columnSettings: dailyHoursColumnSettings,
    defaultReportFields: getDefaultReportFields(dailyHoursReport),
  });

  const sortedReport = useMemo(() => (
    G.isNilOrEmpty(uiReportFields) ?
    dailyHoursReport : G.getSortedReport(uiReportFields, dailyHoursReport)
  ), [uiReportFields]);

  const elementActionsComponent = (data: Object) => (
    <IconWrapper px={12} cursor='pointer' onClick={(e: Object) => handleClickDriverDailyHoursActions(e, data)}>
      {I.threeDots()}
    </IconWrapper>
  );

  return (
    <Table
      tableWrapperPB={40}
      showEditView={true}
      report={sortedReport}
      itemList={dailyHours}
      shouldUseUIFilters={true}
      useSearchableColumns={true}
      withResizableColumns={true}
      tableSettings={tableSettings}
      useNewTitleFilterInputs={true}
      columnSettings={dailyHoursColumnSettings}
      handleClickEditOrder={handleOpenEditView}
      renderRightStickedComponent={elementActionsComponent}
      filterProps={G.getFilterPropsFromColumnSettings(dailyHoursColumnSettings)}
    />
  );
};

export default DailyHoursTab;
